<template>
  <el-table
    ref="tb1"
    size="medium"
    v-loading="loading"
    class="custom-table"
    :empty-text="loading ? ' ': $t('com_no_data')"
    :highlight-current-row="type === 'radio' || type === 'radioCheckbox'"
    :data="columnList.length ? delayList(initData) : []"
    :show-summary='showSummary'
    :summary-method="summaryMethod"
    :row-class-name="rowClassName"
    @current-change="onCurrentRow"
    @selection-change="selectionChange"
    @header-dragend="onHeaderDrag"
    @sort-change="onSortChange"
    @filter-change="onFilterChange"
    @row-click="onRowClick($event, 'tb1')"
    @expand-change="expandChange($event, 'tb1')"
    :class="{ 'border-right':boderRight }"
    v-bind="$attrs"
    v-on="$listeners"
    :border="border"
    :stripe="stripe"
  >
    <slot name="prepose"></slot>
    <el-table-column
      v-if="expand"
      type="expand"
    >
      <template slot-scope="scope">
        <slot
          name="expand"
          v-bind="{
              $index: scope.$index,
              row: scope.row,
              column: scope.column
            }"
        ></slot>
      </template>
    </el-table-column>
    <el-table-column
      v-if="index"
      type="index"
      label="#"
    ></el-table-column>
    <!-- 多选列 -->
    <el-table-column
      v-if="type === 'checkbox' || type === 'radioCheckbox'"
      type="selection"
      width="44"
      fixed="left"
      :selectable="onSelectable"
    ></el-table-column>
    <!-- 配置列 -->
    <template v-for="(item, index) in columnList">
      <!-- 非自定义列 -->
      <el-table-column
        v-if="!slots.includes(item.columnCode)"
        :key="index"
        :index="index"
        :prop="item.columnCode"
        :label="item.columnName"
        :min-width="item.width"
        :formatter="formatColumn"
        :sortable="item.isSort && isFilter ? 'custom' : false"
        :fixed="item.isFixed ? 'right' : null"
        :column-key="item.columnCode"
        :filter-multiple="true"
        :filters="isFilter ? item.filters : undefined"
        show-overflow-tooltip
      >
        <template
          :slot="slots.includes(`${item.columnCode}Header`) ? 'header' : ''"
          slot-scope="scope"
        >
          <slot
            :name="`${item.columnCode}Header`"
            v-bind="{
              $index: scope.$index,
              row: scope.row,
              column: scope.column
            }"
          ></slot>
        </template>
      </el-table-column>
      <!-- 自定义列 -->
      <el-table-column
        v-if="slots.includes(item.columnCode)"
        :key="index"
        :index="index"
        :prop="item.columnCode"
        :label="item.columnName"
        :min-width="item.width"
        :formatter="formatColumn"
        :sortable="item.isSort && isFilter ? 'custom' : false"
        :fixed="item.isFixed ? 'right' : null"
        :column-key="item.columnCode"
        :filter-multiple="true"
        :filters="isFilter ? item.filters : undefined"
        show-overflow-tooltip
      >
        <template
          :slot="slots.includes(`${item.columnCode}Header`) ? 'header' : ''"
          slot-scope="scope"
        >
          <slot
            :name="`${item.columnCode}Header`"
            v-bind="{
              $index: scope.$index,
              row: scope.row,
              column: scope.column
            }"
          ></slot>
        </template>
        <template slot-scope="scope">
          <slot
            :name="item.columnCode"
            v-bind="{
              $index: scope.$index,
              row: scope.row,
              column: scope.column
            }"
          ></slot>
        </template>
      </el-table-column>
    </template>
    <slot></slot>
    <slot
      slot="append"
      name="append"
    ></slot>
    <!-- 占位列 -->
    <el-table-column v-if="!columnList.length"></el-table-column>
  </el-table>
</template>

<script>
import apis from '@/utils/apis';



export default {
  props: {
    columnRef: String, // 配置列Ref
    loading: Boolean, // 加载
    tableCode: String, // 表格编码
    value: [Array, Object], // 单选或多选绑定值
    data: Array, // 表格数据
    index: Boolean, // 显示行数
    type: String, // radio(单选), checkbox(多选)
    onlyArr: Array, // 保留表格列code数组（优先级高于filterArr）
    filterArr: Array, // 过滤表格列code数组
    isFilter: { type: Boolean, default: true }, // 是否启用sort和filter
    selectableKey: { type: String, default: 'isExists' },
    clickSelection: Boolean, // 点击是否选中该行（toggleRowSelection）
    expand: { type: Boolean, default: false },
    showSummary: { type: Boolean, default: false },
    border: { type: Boolean, default: true },
    boderRight: { type: Boolean, default: false },
    summaryMethod: { type: Function },
    rowClassName: { type: Function },
    // 斑马纹
    stripe: {
      type: Boolean,
      default: false
    },
    column: {
      type: Array,
      default() {
        return [];
      },
    },
    slots: {
      type: Array,
      default() {
        return ['action'];
      },
    },
  },
  created() {
    this.$on('clearFilter', (columnKey) => {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.tb1.clearFilter(columnKey);
        });
      }, 300);
    });
    this.$on('toggleRowSelection', (item, value) => {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.tb1.toggleRowSelection(item, value);
        });
      }, 300);
    });
    this.$on('clearSelection', () => {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.tb1.clearSelection();
        });
      }, 300);
    });
    this.$on('setCurrentRow', (row) => {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.tb1.setCurrentRow(row);
        });
      }, 300);
    });
  },
  watch: {
    tableCode(val) {
      if (val) {
        this.getTableColumn();
      }
    },
  },
  data() {
    return {
      initData: false,
      tableColumn: [],
      columnDictionary: {},
    };
  },
  computed: {
    columnList() {
      const list = this.tableCode ? this.tableColumn : this.column;
      return list.filter(t => t.selected);
    },
  },
  mounted() {
    this.initTable();
    this.getTableColumn();
  },
  methods: {
    // 初始选中
    initTable: function () {
      if (this.type === 'radio' && this.value) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.tb1.setCurrentRow(this.value);
          });
        }, 300);
      }
      if ((this.type === 'checkbox' || this.type === 'radioCheckbox') && this.value) {
        this.value.forEach((row) => {
          this.$refs.tb1.toggleRowSelection(row, true);
        });
      }
    },
    // 表格重新布局
    doLayout: function () {
      this.$nextTick(() => {
        if (this.$refs.tb1) {
          this.$refs.tb1.doLayout();
        }
      });
    },
    // 获取表格列
    getTableColumn: function () {
      if (!this.tableCode) {
        this.formatTable(this.column);
        return;
      }
      this.$getJSON(apis.TableColumnGet, { tableCode: this.tableCode }).then((res) => {
        const tableColumn = res.data || [];
        this.formatTable(tableColumn);
      });
    },
    formatTable: function (cols) {
      let tableColumn = cols || [];
      // 过滤表格列
      if (this.onlyArr && this.onlyArr.length) {
        tableColumn = tableColumn.filter(col => this.onlyArr.includes(col.columnCode));
      }
      // 过滤表格列
      if (this.filterArr && this.filterArr.length) {
        tableColumn = tableColumn.filter(t => !this.filterArr.includes(t.columnCode));
      }
      // 获取字典
      const codes = tableColumn.filter(t => t.isFormat && t.formatRule === 'dic_group').map(f => f.dicGroup);
      const hasDate = tableColumn.find(t => t.formatRule === 'tableField_date');
      if (hasDate) {
        codes.push('bas_tableField_dateFormat');
      }
      if (codes.length) {
        this.getDictionary(
          codes.join(','),
          (dictionary) => {
            tableColumn.forEach((item) => {
              // 多选表格列过滤
              if (item.isFormat && item.formatRule === 'dic_group' && item.checkbox) {
                const propList = dictionary[item.dicGroup].map(t => ({ text: t.name, value: t.value, code: t.code }));
                const rules = item.checkboxRule && item.checkboxRule.split(',');
                item.filters = item.checkboxRule ? propList.filter(t => rules.includes(t.code)) : propList;
              }
            });
            this.tableColumn = tableColumn;
            this.$nextTick(() => {
              this.$emit('column', { tableCode: this.tableCode, tableColumn, columnRef: this.columnRef });
            });
            this.doLayout();
          },
          'columnDictionary'
        );
      } else {
        this.tableColumn = tableColumn;
        this.$nextTick(() => {
          this.$emit('column', { tableCode: this.tableCode, tableColumn, columnRef: this.columnRef });
        });
        this.doLayout();
      }
    },
    // 格式化表格列
    formatColumn: function (row, col) {
      const column = this.columnList[col.index];
      if (column.isFormat) {
        const dictionary = this.tableCode ? this.columnDictionary : this.$store.state.dictionary;
        let result = '';
        // 格式化字典
        if (column.formatRule === 'dic_group' && column.dicGroup) {
          const group = this.$transformDicValue(dictionary[column.dicGroup]);
          const value = row[col.property];
          result = group[`${value}`] || value || '-';
        }
        // 格式化日期
        if (column.formatRule === 'tableField_date' && column.dicGroup) {
          const group = this.$transformDicCode(dictionary.bas_tableField_dateFormat);
          const param = group[column.dicGroup];
          try {
            if (param === 'formatSecToHm') {
              // formatSecToHm
              // 特殊处理时间 h:m
              const field = col.property.replace('Format', '');
              result = this[`$${param}`](row[field], false);
            } else if (param === 'formatSecToHh') {
              // formatSecToHh
              // 特殊处理时间 h小时
              const field = col.property.replace('Format', '');
              result = this[`$${param}`](row[field]);
            } else if (param === 'toFixed') {
              // 如果是0 '-' 要用'-' 显示
              if (!row[col.property] || row[col.property] === '-') {
                result = '-';
              } else {
                // toFixed 数据保留两位小数特殊处理
                result = this[`$${param}`](row[col.property]);
              }
            } else if (row[col.property]) {
              result = this.momentAmPm(this.$momentLocal(row[col.property], param));
            }
          } catch (e) {
            //
          }
        }
        return result === undefined || result === '' ? '-' : result;
      } else {
        const value = row[col.property];
        return value === undefined || value === '' ? '-' : value;
      }

    },
    delayList: function (init) {
      setTimeout(() => {
        this.initData = true;
      }, 150);
      return init ? this.data : [];
    },
    onRowClick(row, name) {
      if (this.clickSelection) {
        if (row.isExists) {
          return;
        }
        this.$refs[name].toggleRowSelection(row);
      }
      this.$emit('row-click', row);
      this.$emit('on-row-click', row);
    },
    expandChange(row) {
      if (this.expand) {
        this.$emit('expand-change', row);
      }

    },
    // 单选选中
    onCurrentRow: function (row) {
      if (this.type === 'radio') {
        this.$emit('input', row || {});
      }
      this.$emit('change', 'radio');
      this.$emit('radio', row || {});
    },
    // 多选选中
    selectionChange: function (selection) {
      this.$emit('input', selection);
      this.$emit('change', 'checkbox');
      this.$emit('checkbox', selection);
    },
    // 表格禁用行
    onSelectable: function (row) {
      return !row[this.selectableKey];
    },
    // 多选过滤
    onFilterChange: function (value) {
      this.$emit('filter', value);
    },
    // 排序
    onSortChange: function ({ prop, order }) {
      this.$emit('sort', { prop, order });
    },
    // 列宽
    onHeaderDrag: function (newWidth, oldWidth, column) {
      const isrDrag = localStorage.headerDrag;
      if (!isrDrag) {
        return;
      }
      const col = this.columnList[column.index];
      this.$postJSON(apis.TableColUpdate, {
        columnId: col.columnId,
        width: newWidth,
      }).then(() => { });
    },
  },
};
</script>
<style lang="scss">
.el-table--group,
.el-table--border {
  border: none !important;
}
.el-table--group::after,
.el-table--border::after {
  display: none;
}

.el-table--border th,
.el-table--border td {
  border-right: none !important;
}

// 带左右边框
.el-table.border-right::before {
  // display: 1px solid #eef2f8;
  height: 0;
}
.border-right .el-table__fixed::before,
.border-right .el-table__fixed-right::before {
  height: 0;
}
.el-table--border.border-right th,
.el-table--border.border-right td {
  border-right: 1px solid #eef2f8 !important;
}
.el-table--border.border-right th:first-child,
.el-table--border.border-right td:first-child {
  border-left: 1px solid #eef2f8 !important;
}

.custom-table {
  $formElHeight: 28px;
  .el-input__inner {
    height: $formElHeight !important;
    line-height: $formElHeight !important;
    padding-left: 8px;
  }
  .el-input__icon {
    line-height: $formElHeight !important;
  }
  .el-input__suffix {
    right: 0;
  }
}
</style>
